// src/constants/termsAndConditions.ts
export const termsAndConditions = `
By submitting this registration, you confirm that the information provided is accurate to the best of your knowledge.

If you register as a volunteer, you consent to a background check where required for child safety and church policy compliance.

You agree to follow VBS safety expectations, check-in/check-out procedures, and event guidelines.

You acknowledge that personal information is handled as described in the Privacy Notice.
`;